export const OFF_CYCLE_PAYRUN_REPORT_LOAD = 'OFF_CYCLE_PAYRUN_REPORT_LOAD'
export const OFF_CYCLE_PAYRUN_REPORT_LOAD_PENDING = 'OFF_CYCLE_PAYRUN_REPORT_LOAD_PENDING'
export const OFF_CYCLE_PAYRUN_REPORT_LOAD_FULFILLED = 'OFF_CYCLE_PAYRUN_REPORT_LOAD_FULFILLED'
export const OFF_CYCLE_PAYRUN_REPORT_LOAD_REJECTED = 'OFF_CYCLE_PAYRUN_REPORT_LOAD_REJECTED'
